import { jsx as s, Fragment as a } from "react/jsx-runtime";
import { highlightTextWithinItems as C } from "./index.es547.js";
import { noop as I } from "lodash/fp";
import { useMemo as c, useState as H } from "react";
import { onItemClick as S } from "./index.es2384.js";
import { MultilineItem as h } from "./index.es79.js";
import { MenuListContainer as D } from "./index.es82.js";
const N = 78, L = 66, g = 62, O = 42, y = 54, F = ({
  items: r,
  maxVisibleItems: m,
  onSelection: E = I,
  onItemSelection: p = I,
  searchTerm: i,
  NoResultsItem: M,
  selectionMode: f = "single",
  disabledVirtualization: _
}) => {
  const e = c(
    () => C({
      searchTerm: i,
      items: r,
      shouldFilter: !0
    }),
    [r, i]
  ), [u, l] = H(), d = (t) => {
    S(e, t, f, p, E);
  }, v = c(() => {
    var n;
    const t = r[0];
    return t != null && t.description ? (n = t.description) != null && n.toString().includes(`
`) ? N : t.thumbnail ? L : t.entityColor ? y : g : O;
  }, [r]);
  return /* @__PURE__ */ s(
    D,
    {
      itemHeight: v,
      itemCount: i ? e.length : r.length,
      maxVisibleItems: m,
      NoResults: M,
      disabledVirtualization: _,
      children: ({ index: t, style: n }) => {
        const o = e[t], T = u - 1 !== t && t !== u;
        return o ? /* @__PURE__ */ s(
          h,
          {
            wrapperStyle: n,
            onClick: () => d(o.value),
            ...o,
            hasDivider: T && (o.hasDivider || !!(e != null && e[t + 1])),
            onMouseEnter: o.isDisabled ? void 0 : () => l(t),
            onMouseLeave: o.isDisabled ? void 0 : () => l(void 0)
          },
          o.value
        ) : /* @__PURE__ */ s(a, {});
      }
    }
  );
};
export {
  F as MultilineDropdownMenu
};
//# sourceMappingURL=index.es73.js.map
